<template>
  <ETooltip
    class="green-queries-explainer"
    :side="side"
    data-test-id="green-queries-explainer"
  >
    <div class="green-queries-explainer__title">
      <EIcon icon="info-circle" class="sponsored__icon" size="s" data-test-id="sponsored-icon" />
      <span>{{ $t('web.relatedQueries.greenExplainer.title') }}</span>
    </div>
    <template #content>
      <section class="green-queries-explainer__body">
        <div class="green-queries-explainer__icon-container">
          <EIcon
            data-test-id="green-queries-explainer-green-leaf-icon"
            aria-hidden="true"
            icon="green-leaf"
            size="m"
            class="green-queries-explainer__icon"
          />
        </div>
        <div class="green-queries-explainer__text-container">
          <p>{{ $t('web.relatedQueries.greenExplainer.text') }}</p>
        </div>
      </section>
    </template>
  </ETooltip>
</template>
<script>
import ETooltip from '~~/common/vue/components/tooltip';
import EIcon from '~~/common/vue/components/icon';
import screen from '~~/common/vue/mixins/screen';

export default {
  components: {
    ETooltip,
    EIcon,
  },
  mixins: [screen()],
  computed: {
    side() {
      if (this.isMobileDisplay) {
        return 'right-bottom';
      }
      return 'left-bottom';
    },
    isMobileDisplay() {
      return !this.isTabletUp && !this.isDesktopUp;
    },
  },
};
</script>
<style lang="scss" scoped>
.green-queries-explainer {
  @include desktop-down {
    padding: 0 $space-m $space-m;
  }
}

.green-queries-explainer__title {
  display: flex;
  align-items: center;

  span {
    margin-left: $space-2s;
  }
}

.green-queries-explainer__icon {
  flex-shrink: 0;
  color: var(--color-decorative-icon);
  transition: color $timing-2s $easing;
}

.green-queries-explainer__icon-container {
  display: flex;
  align-items: center;
}

.green-queries-explainer__text-container {
  padding-left: $space-1s;

  p {
    margin: 0;
    font-size: $font-m;
    font-weight: $font-weight-m;
    color: var(--color-text-primary);
  }
}

.green-queries-explainer__body {
  display: flex;
  justify-content: space-between;
}

</style>
